export const parseOffsetMinutes = (value?: string) => {
	if (!value) return 0;
	const match = value.trim().match(/^([+-])(\d{2}):(\d{2})(?::\d{2})?$/);
	if (!match) return 0;

	const [, sign, hours, minutes] = match;
	const totalMinutes = Number(hours) * 60 + Number(minutes);
	return sign === "+" ? totalMinutes : -totalMinutes;
};

export const parseTimeToMinutes = (value?: string) => {
	if (!value) return null;
	const [hours, minutes] = value.split(":");
	if (hours == null || minutes == null) return null;
	const h = Number(hours);
	const m = Number(minutes);
	if (Number.isNaN(h) || Number.isNaN(m)) return null;
	return h * 60 + m;
};
